import { IRIMSActions } from "../../types";

export function setInventoryRequest(state, action: any): any {
  const { code, itemNumber, ...others} = action.payload;

  if (parseInt(others.quantity) === 0) {
    return unsetInventoryRequest(state, action);
  }

  const items = JSON.parse(localStorage.getItem('inventory-request') || '{}');
  items[code] = items[code] || {};
  items[code][itemNumber] = others;

  localStorage.setItem('inventory-request', JSON.stringify(items));
  return { ...state, items};
}

export function unsetInventoryRequest(state, action): any {
  const { code, itemNumber } = action.payload;
  const items = JSON.parse(localStorage.getItem('inventory-request') || '{}');
  delete items[code][itemNumber];

  localStorage.setItem('inventory-request', JSON.stringify(items));
  return { ...state, items};
}

export function clearInventoryRequest(state, action): any {
  const { code } = action.payload;
  const items = JSON.parse(localStorage.getItem('inventory-request') || '{}');
  delete items[code];
  
  localStorage.setItem('inventory-request', JSON.stringify(items));
  return { ...state, items: {} };
}